var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-no-wrap"},[_vm._v(_vm._s(_vm._f("time")(_vm.item.updated_at)))]),_c('div',{staticClass:"text-caption"},[_vm._v(_vm._s(_vm.item.updated_by))])])
}
var staticRenderFns = []

export { render, staticRenderFns }